import api from "./api";

class UserService {
  update(user) {
    return api.put(`v1/api/users/members/${user?.member.id}`, user)
  }

  campaignPost(body) {
    return api.post(`v1/api/campaigns/${body.campaignId}`, body)
  }

  campaignGet(id) {
    return api.get(`v1/api/campaigns/${id}`)
  }
}

export default new UserService();